module.exports = __webpack_public_path__ + "img/recette-edit-1general.6ced0acb.png";